import { Album, http } from '@Techedge/digitalportal-shared'
import { SortingType } from '../models/new-resource'
import { SearchByValues } from '../models/photo'

export class GalleryService {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static PROFILE_URL: string = GalleryService.BASE_URL + `/profileapi/profilemanagement`
    static GALLERY_BASE_URL: string = GalleryService.BASE_URL + `/galleryapi`
    static PROJECTS_BASE_URL: string = GalleryService.BASE_URL + `/projectsapi`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static CreateAlbum = (album: Album): any => {
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/album`,
            album,
            GalleryService.headersObj
        )
    }

    static EditAlbum = (album: Album): any => {
        return http.put<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/album/${album.id}`,
            album,
            GalleryService.headersObj
        )
    }

    static PreviewAlbum = (
        album: Album,
        params?: {
            tab: 'all' | 'filtered' | 'added'
            page?: number | string
            pageSize?: number | string
            sortingType: SortingType
        }
    ): any => {
        let _params = {
            tab: 'all',
            page: 1,
            pageSize: 4,
            sortingType: 'lastUpdated',
            ...params,
        }
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/album/preview`,
            { album, ..._params },
            GalleryService.headersObj
        )
    }

    static GetSearchUserList = (searchBy: SearchByValues, value: string) => {
        return http.get<any>(
            `${GalleryService.PROFILE_URL}/user/search?${searchBy}=${value}`,
            GalleryService.headersObj
        )
    }
    static GetAlbumDetails = (albumId: string): any => {
        return http.get<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/album/${albumId}/info`,
            GalleryService.headersObj
        )
    }
    static PhotoDetails = (id: string): any => {
        return http.get<any>(
            `${GalleryService.GALLERY_BASE_URL}/attachment/${id}`,
            GalleryService.headersObj
        )
    }
    static GetSpecialCollections = (): any => {
        return http.get<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/albums?isSpecialCollection=true`,
            GalleryService.headersObj
        )
    }
    static GetPackagePhotoList = (id: string): any => {
        return http.get<any>(
            `${GalleryService.GALLERY_BASE_URL}/package?storeId=${id}`,
            GalleryService.headersObj
        )
    }
    static DeletePhotoByPackage = (body: { storeId: string; photoId: string }): any => {
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/package/delete`,
            body,
            GalleryService.headersObj
        )
    }
    static SaveAsDraftPackage = (body: { storeId: string }): any => {
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/package/save`,
            body,
            GalleryService.headersObj
        )
    }
    static SaveChangesPackage = (body: { storeId: string; photoIdList: string[] }): any => {
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/package/update`,
            body,
            GalleryService.headersObj
        )
    }
    static PublishPackage = (body: { storeId: string }): any => {
        return http.post<any>(
            `${GalleryService.GALLERY_BASE_URL}/package/publish`,
            body,
            GalleryService.headersObj
        )
    }

    static AddPhotosToAlbum = (albumId: string, attachmentIds: string[]) => {
        return http.put<any>(
            `${GalleryService.GALLERY_BASE_URL}/my/album/${albumId}/attachments`,
            { attachmentIds },
            GalleryService.headersObj
        )
    }

    static GetAlbumsList = (params: any) => {
        if (!params.title) delete params.title
        return http.get<any>(`${GalleryService.GALLERY_BASE_URL}/my/albums`, {
            ...GalleryService.headersObj,
            params: {
                sortingType: params.sortingType ?? 'lastUpdated',
                page: params.page ?? 1,
                pageSize: 10,
                ...params,
            },
        })
    }
    static updatePhotoTagList = (params: {
        attachmentId: string
        tags: { name: string; x: number; y: number }[]
    }) => {
        return http.put<any>(
            `${GalleryService.PROJECTS_BASE_URL}/activities/update_photo/${params.attachmentId}`,
            { tags: params.tags },
            {
                ...GalleryService.headersObj,
            }
        )
    }
}
